import { SearchResultItem, AllApps } from '../types';
import { MOCK } from '../constants';
import { tokenize, scoreItem } from '../utils/helpers';

export interface Filters {
  app: AllApps;
  project: string;
  type: string;
  discipline: string;
  status: string;
  updated: { from: string | null; to: string | null; } | null;
}

export interface SearchArgs {
  query: string;
  activeApp: AllApps;
  filters: Filters;
  sort: string;
}

export function mockSearch({ query, activeApp, filters, sort }: SearchArgs): SearchResultItem[] {
  const terms = tokenize(query);
  let items: SearchResultItem[] = MOCK.filter((it) => activeApp === "All Apps" || it.app === activeApp);
  
  if (filters.app && filters.app !== "All Apps") items = items.filter((it) => it.app === filters.app);
  if (filters.project && filters.project !== "All") items = items.filter((it) => it.project === filters.project);
  if (filters.type && filters.type !== "All") items = items.filter((it) => it.type === filters.type);
  if (filters.discipline && filters.discipline !== "All") items = items.filter((it) => it.discipline === filters.discipline);
  if (filters.status && filters.status !== "All") items = items.filter((it) => it.status === filters.status);
  
  if (filters.updated) {
    const { from, to } = filters.updated;
    items = items.filter((it) => {
      const d = new Date(it.updatedAt).getTime();
      const okFrom = from ? d >= new Date(from).getTime() : true;
      const okTo = to ? d <= new Date(to).getTime() : true;
      return okFrom && okTo;
    });
  }

  let scored = items.map((it) => ({ ...it, _score: terms.length ? scoreItem(it, terms) : 0.0001 }));
  
  if (sort === "Recent") {
    scored.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  } else if (sort === "Popular") {
    scored.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
  } else {
    scored.sort((a, b) => (b._score ?? 0) - (a._score ?? 0));
  }
  
  return scored;
}
